import { NavPills } from '@hyperflake/react-ui-library';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

const DocumentLayout = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { clientId } = useParams();

    const docsBase = `/clients/${clientId}/documents`;
    const externalLinksPath = `${docsBase}/external-links`;

    const navItems = [
        {
            content: 'Documents',
            href: docsBase,
            isActive: !externalLinksPath || pathname === docsBase,
        },
        {
            content: 'External Links',
            href: externalLinksPath,
            isActive: pathname === externalLinksPath || pathname.startsWith(`${externalLinksPath}/`),
        },
    ];

    return (
        <>
            {/* <div className="p-3">
                <NavPills
                    items={navItems.map((item) => ({
                        content: <Link to={item.href}>{item.content}</Link>,
                        isActive: item.isActive,
                        onClick: () => navigate(item.href),
                    }))}
                />
            </div> */}

            <Outlet />
        </>
    );
};

export default DocumentLayout;
